import React from 'react';

const HelpItem6 = () => {
  return (
    <>
      <p className='p'>
        When you select the gymMember page. A list of gymMembers will be listed.
      </p>
      <p className='p'>
        Each gymMember with have a link to the restaurant they work for.
        Clicking on the restaurant name will give you the restaurant detail
        which includes menus, assocaites and entertainment items.
      </p>
      <p className='p'>
        The gymMembers that are in will have a green dot on their photo.
      </p>
    </>
  );
};

export default HelpItem6;
